<div class="" style="margin-left: -240px; margin-right: -10px; background-color: white; height: calc(100vh - 290px); width: 98vw;">

  <mat-toolbar class="no-background" style="width: 1150px;">
    <span style="font-size: 20px;">月次損益報告書　</span>
    <span class="spacer"></span>
    <span style="padding: 8px; font-size: 14px;">{{userinfo}}</span>
  </mat-toolbar>

  <div style="color: red; font-size: 13px; line-height: normal; margin-bottom: 1em;">
    ※通貨単位がJPYの場合、1円未満の数値がある場合は切り捨てて表記しています。<br>
    ※通貨単位がUSD、AUD、GBP、EUR、CHFの場合、1セント未満の数値がある場合は切り捨てて表記しています。<br>
    ※各損益率は <a (click)="blankOpen($event, '/client/monthlyProfitSimple')" href="javascript:void(0)">月報（損益率）</a> を使用しています。<br>
    ※2023年1月～2025年6月のデータ（<span style="background-color: #fff3cd; color: black;">　背景色がアイボリーの行　</span>）は、旧「月次損益報告」のデータを引用して表示していますので、「月管理手数料」「先月末残高」「調整額」は表示されません。<br>
    ※2022年12月以前の月次損益が必要な方はサポートにお問い合わせください。<br>
  </div>

  <div>
    <div style="display: flex; justify-content: space-around; border: 1px solid #ccc; border-radius: 8px; padding: 8px;">
      <button matFab (click)="changeAd(prevAd)" [disabled]="currentAd <= 202301" *ngIf="mode === 'monthly'">◀</button>

      <div style="margin-top: 6px; font-size: 20px;">{{title}}</div>

      <button matFab (click)="changeAd(nextAd)" [disabled]="currentAd >= latestAd" *ngIf="mode === 'monthly'">▶</button>

      <button mat-raised-button color="primary" (click)="changeAd(currentAd)" *ngIf="mode === 'cap_id'">{{ym}} に戻る</button>

      <button mat-raised-button (click)="export()" *ngIf="data">
        CSVダウンロード
      </button>

    </div>

    <span *ngIf="data">

      <div class="list-container" >
        <ag-grid-angular
          #grid
          class="ag-theme-alpine compact-grid"
          style="width: 100%; height: calc(100vh - 495px);"
          [localeText]="localeText"
          [defaultColDef]="defaultColDef"
          [columnDefs]="columnDefs"
          [rowData]="data"
          (firstDataRendered)="onFirstDataRendered($event)"
          (gridReady)="onGridReady($event)"
          (rowDoubleClicked)="onRowClicked($event)"
          [rowSelection]="{mode: 'singleRow', enableClickSelection: true, checkboxes: false}"
          [gridOptions]="gridOptions"
        >
        </ag-grid-angular>
      </div>

    </span>
  </div>

</div>

